import {CalendarRange} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const anyAccessRoutes = [
  {
    path: 'work-schedule',
    loader: protectedLoader('WORK_SCHEDULE', 'VIEW_WORK_SCHEDULE'),
    async lazy() {
      const {WorkSchedulePage} = await import('./pages/WorkSchedulePage');
      return {element: <WorkSchedulePage />};
    },
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/work-schedule',
    text: i18n.t('Work schedule'),
    icon: <CalendarRange />,
    permission: 'VIEW_WORK_SCHEDULE',
    entitlement: 'WORK_SCHEDULE',
  },
] as MenuItemElement[];
